import { z } from 'zod/v4'

const containerIdSchema = z
  .string()
  .trim()
  .transform((value) => value.toUpperCase())
  .pipe(
    z
      .string()
      .max(64)
      .regex(/^GTM-[A-Z0-9]+$/, 'Enter a Google Tag Manager container ID, like GTM-XXXXXXX.')
  )

export const googleTagManagerIntegrationSchema = z.object({
  container_id: containerIdSchema,
})

export function normalizeGoogleTagManagerContainerId(value: string | null | undefined): string {
  return String(value ?? '')
    .trim()
    .toUpperCase()
}
